<template>
  <div class="image-handle-container">
    <h3 class="title">
      <span>图片处理</span>
    </h3>
    <div class="handle-form-container">
      <div class="handle-form-container-bg"></div>
      <el-form :model="handleForm" ref="handleForm" class="handle-form" inline>
        <el-form-item class="handle-form-item" prop="path" :rules="handleFormRules">
          <el-input prefix-icon="el-icon-picture-outline-round" class="handle-input" v-model="handleForm.path" autocomplete="off" size="mini" placeholder="请输入图片地址" clearable></el-input>
        </el-form-item>
        <el-form-item class="handle-form-item">
          <el-button type="primary" size="mini" @click="handleImage">处理</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 对话框 -->
    <el-dialog :top="dialog.top" :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :before-close="destroyComponent" :close-on-press-escape="false">
      <component :is="dialog.component" @close="destroyComponent" :row="row" :imageInfo="imageInfo" />
    </el-dialog>
  </div>
</template>

<script>
import { dialogMixin } from "@/common/mixins/";
import { getExt, isImg } from '@/common/utils/ext.js';
import imageHandle from '@/views/fileManage/components/imageHandle.vue'
import axios from 'axios';
let validateImagePath = (rule, value, callback) => {
  if (!(/^https\:\/\/front|uat\-xps|asset|daily|qa|grey|prod\-cdn\.xsyx\.xyz\//.test(value))) {
    callback(new Error('XPS不支持处理图片地址！'));
  } else if (!isImg(value)) {
    callback(new Error('只能处理特定后缀的图片格式！'));
  } else {
    callback();
  }
}
export default {
  mixins: [dialogMixin],
  data () {
    return {
      handleForm: {
        path: ''
      },
      handleFormRules: [
        { required: true, message: '图片地址不能为空！' },
        { validator: validateImagePath, trigger: 'blur' }
      ],
      row: null,
      imageInfo: null,
    }
  },
  methods: {
    // 图片处理
    handleImage () {
      this.$refs['handleForm'].validate(async (valid) => {
        if (valid) {
          const row = {};
          row.path = this.handleForm.path;
          row.isImg = isImg(this.handleForm.path);
          row.ext = getExt(this.handleForm.path);
          const { data } = await axios.get(`${row.path}?imageInfo`);
          data.width = data.width - 0;
          data.height = data.height - 0;
          this.imageInfo = data;
          this.row = row;
          this.setDialog(true, "图片处理", imageHandle, "1000px", "5vh");
        } else {
          return false;
        }
      });
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
  }
}
</script>

<style lang="scss" scoped>
.image-handle-container {
  height: 100%;
  .handle-form-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 45px);
    &-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      background: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/cloud-handle.png")
        no-repeat center;
      background-size: contain;
      opacity: 0.2;
    }
  }
}
</style>